// API configuration
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://fg0jf2txt9.execute-api.us-east-2.amazonaws.com/prod';